news11.vue<template>
<div>
		<sub-header bizCd="10"/>
	 	<div class="sub_visual sub10">
            <div class="container">
                <div class="sub_txt">
                    <div class="tit">보도자료</div>
                    <div class="comment">언론에 소개된 에듀윌의 다양한 소식을 만나보세요.</div>
                </div>
            </div>
        </div>
        <div class="contents aos-all">
            <div class="container">
                <div class="sec">
                    <h3>보도자료</h3>
                    <div class="board">
                        <div class="board_header">
                            <h4>에듀윌, 라오스 진출 본격화…라오스 산업통상부 차관·속싸이그룹 회장단과 회동</h4>
                            <div class="board_meta">
<!--                                <ul>-->
<!--                                    <li>등록일 : 22.05.24</li>-->
<!--                                    <li>조회수 : 142</li>-->
<!--                                </ul>-->
                            </div>
                        </div>
                      <div class="board_body">
                            <div class="board_content">
                              <h2>에듀윌, 라오스 진출 본격화…라오스 산업통상부 차관·속싸이그룹 회장단과 회동</h2>
                              <p>&nbsp;</p>
                              <p>- 속싸이 그룹 회장 방한… 라오스 시장 진출 위한 실무 논의 진행<br>- 분텍 두앙사반 라오스 산업통상부 차관과 면담 후 전북대학교, 전라북도청,
                                농촌진흥청 방문<br>- 한국의 선진 교육 시스템 소개하며 라오스 협력 기반 마련<br>&nbsp;</p>
                              <p>
                                <figure class="image"><img src="//company.eduwill.net/contents/img/20250203163436.jpg"></figure>
                                <br><br>▲사진 설명: (왼쪽 세 번째부터 차례로) EBS미디어 박성호
                                대표, 이동원 액티부키 대표, 에듀윌 양형남 대표, 속싸이 그룹 속싸이 솜차이눅 회장, 판파킷 온판달라 부회장, 이정협 라오스 산업통상부 경제자문관과 주요
                                관계자들이 실무 논의 후 기념촬영을 하고 있다.</p>
                              <p>&nbsp;</p>
                              <p><br>(2024-11-20) 종합교육기업 에듀윌(대표 양형남)이 지난 18일 라오스의 대표적인 무역 및 투자 기업인 속싸이 그룹(SOKXAY Group)
                                회장단이 서울 구로구 본사를 방문했다고 20일 밝혔다.</p>
                              <p>&nbsp;</p>
                              <p>이번 방문은 에듀윌이 지난 9월 라오스를 포함한 동남아 시장 진출을 추진하며 체결한 다자간 업무협약(MOU)의 후속 조치로, 실질적인 협력 방안을 논의하는
                                자리로 마련됐다.</p>
                              <p>&nbsp;</p>
                              <p>속싸이 그룹의 속싸이 솜차이눅(Sokxay Somchayneuk) 회장을 포함한 주요 임원들은 민간파트너사인 액티부키와 전북특별자치도의 공식 초청으로 분텍
                                두앙사반(Bountheung Douangsavanh) 라오스 산업통상부 차관과 함께 방한했다.</p>
                              <p>속싸이 그룹은 2005년 설립된 라오스의 대표적인 대기업으로, 무역, 보험, 부동산 등 다양한 분야에 진출해 있다.</p>
                              <p>&nbsp;</p>
                              <p>이번 회동에는 양형남 에듀윌 대표와 함께 박성호 EBS미디어 대표, 이동원 액티부키 대표, 김민수 메이트아이(호텔엔조이) 대표 그리고 이정협 라오스
                                산업통상부 경제자문관이 함께 참석해 실무적인 협력 방안을 논의했다. 에듀윌은 속싸이 그룹 방문단에게 한국의 선진화된 교육 및 직업훈련 시스템과 프로그램을
                                소개하며, 라오스 내 한국어 교육 및 직업훈련 관련 협력 방안을 협의했다.</p>
                              <p>&nbsp;</p>
                              <p>양형남 에듀윌 대표는 "한국의 교육 시스템이 라오스와 같은 동남아 국가에서 직업 역량 강화와 경제 발전에 기여할 수 있기를 기대한다"며 "이번 협력을 통해
                                양국 간 교육 문화 교류를 더욱 확대해 나가겠다"고 말했다.</p>
                              <p>&nbsp;</p>
                              <p>속싸이 솜차이눅 회장은 "한국의 앞선 교육 시스템과 경험이 라오스의 인재 육성과 산업 발전에 큰 역할을 할 것"이라며 "앞으로 에듀윌과의 협력을 지속적으로
                                확대해 나가기를 희망한다"고 말했다.</p>
                              <p>&nbsp;</p>
                              <p>에듀윌은 이날 방문단과의 논의를 통해 라오스 현지에서의 교육 인프라 구축 방안과 함께 장기적인 협력 모델을 구상하며, 라오스 진출 계획의 초석을
                                다졌다.</p>
                              <p>&nbsp;</p>
                              <p>다음 날인 19일에는 에듀윌 양형남 대표와 박성호 EBS미디어 대표, 이동원 액티부키 대표, 김민수 메이트아이(호텔엔조이) 대표가 전라북도 전주시를 방문해
                                분텍 두앙사반(Bountheung Douangsavanh) 라오스 산업통상부 차관과 면담을 가졌다. 이 자리에서 라오스의 시장 특성에 부합하는 교육 및 관광
                                콘텐츠 개발 방향에 대한 논의를 진행했다. 이어서 전북대학교, 전라북도청, 농촌진흥청을 방문해 양국 간 교류 활성화를 위한 협력 방안을 모색했다.<br>&nbsp;
                              </p>
                            </div>
                        </div>
                        <div class="board_nav">
                            <ul>

                                <!-- 이전 보도 기사가 있을 경우 -->

                                <li class="prev">
                                    <router-link to="/edu/newsRelease/promotionVideo/news18" data-value="315283">
                                        <strong>이전</strong>
                                        <span>에듀윌, 케어런츠·한국요양보호협회와 맞손… 프리미엄 요양보호사 양성 나선다!</span>
                                    </router-link>
                                </li>

                                <!-- //이전 보도 기사가 있을 경우 -->

                              <!-- 다음 보도 기사가 있을 경우 -->
                              <li class="next">
                                <router-link to="/edu/newsRelease/promotionVideo/news16" data-value="315283">
                                  <strong>다음</strong>
                                  <span>에듀윌, EBS미디어, 메이트아이, 액티부키, 동남아시아 시장 진출 위한 공동 MOU 체결</span>
                                </router-link>
                              </li>
                              <!-- //다음 보도 기사가 있을 경우 -->

                            </ul>
                        </div>
                        <div class="board_footer">
                            <div class="button-area">
                                <router-link to="/edu/newsRelease/main" class="lg-btn">
                                목록으로
                                </router-link>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SubHeader from "@/layouts/SubHeader";

export default {
	name: "MainOnlineEdu",
	components: {SubHeader},
	data() {
		return {
			swiper : ""
		}
	},
	
	computed: {
	},
	
	methods: {
	},
	
	created() {
	},
	beforeMount() {
	},
	mounted() {
		AOS.init({ easing: 'ease-in-out-sine' })
		
		this.swiper = new Swiper("#vi-role.swiper-container", {
	        loop: true,
	        loopFillGroupWithBlank: true,
	        navigation: {
	          nextEl: ".swiper-button-next",
	          prevEl: ".swiper-button-prev"
	        }
	    });
		
		$(".pa_slider_scroll").simplyScroll({
	        customClass:'vert',
			speed: 5,
	        pauseOnHover : true
	    });
	},
	beforeDestroy() {
	},
	destroyed() {
	}
}
</script>
